module.exports = __webpack_public_path__ + "img/pickup.e24fdfae.svg";